'use client'

import dynamic from 'next/dynamic'
import { TokenStorage } from 'shared/libs/storage'

import { useGetMeQuery } from 'modules/Auth/model/api'
import { useAuthSlice } from 'modules/Auth/model/slice'
import { CartBadge } from 'modules/Cart/components/CartBadge/Universal'

import { HeaderFavorite } from '../../HeaderFavorite/Desktop'

import styles from './HeaderAction.module.scss'

const HeaderProfile = dynamic(
  () => import('shared/common/Header/ui/HeaderProfile/Desktop/HeaderProfile'),
  {
    ssr: false,
  },
)
export function HeaderActions() {
  useAuthSlice()
  const token = TokenStorage.getFromStorage()
  useGetMeQuery(undefined, { skip: !token })

  return (
    <div className={styles.actions}>
      <div>
        <HeaderProfile />
      </div>
      <HeaderFavorite />
      <CartBadge />
    </div>
  )
}
